/** *********************** EVENT_NAME *************************/
export const AD_PROMOTION_DRAWER_PERF = 'ad_promotion_drawer_perf'
export const PROMOTION_TTI_PERF = 'promotion_tti_perf'
export const PROMOTION_TABLE_PERF = 'promotion_table_perf'
export const PROMOTION_DRAWER_PERF = 'ad_promotion_drawer_perf'
export const KEYWORD_TTI_PERF = 'keyword_tti_perf'
export const KEYWORD_LIST_PERF = 'keyword_list_perf'
export const AD_TTI_PERF = 'ad_tti_perf'
export const CREATIVE_TTI_PERF = 'creative_tti_perf'

export const REPORTER_TTI_PERF = 'reporter_tti_perf'
export const REPORTER_COMPONENT_PERF = 'reporter_component_perf'
export const REPORTER_DOWNLOAD_PERF = 'reporter_download_perf'

// will be deprecated
export const AD_PROMOTION_TABLE_PERF = 'ad_promotion_table_perf'
export const CREATIVE_PROMOTION_TABLE_PERF = 'creative_promotion_table_perf'
export const DETAIL_DRAWER_CREATIVE_LIST_PERF = 'detail_drawer_creative_list_perf'
/** *********************** /EVENT_NAME *************************/

// common mark names
export const REQUEST_START = 'requestStart'
export const REQUEST_END = 'requestEnd'
export const RENDER_END = 'renderEnd'

export const getStaticTags = () => ({
  ads_session_id: window.sessionId || '',
  slardar_session_id: window.Slardar?.shared?.config?.commonParams?.slardar_session_id || '',
  adv_id: GLOBAL_VAR.advertiser?.id || '',
  first_industry_id_v3: GLOBAL_VAR.advertiser?.first_industry_id_v3 || '',
  second_industry_id_v3: GLOBAL_VAR.advertiser?.second_industry_id_v3 || '',
  customer_type: GLOBAL_VAR.customerType || '',
  user_id: GLOBAL_VAR.coreUser?.id || ''
})

const SLARDAR_SESSION_ID = (() => {
  if (!window.Slardar) return ''
  if (typeof window.Slardar.config === 'function') {
    const { sessionId } = window.Slardar.config()
    return sessionId
  } else {
    return window.Slardar?.shared?.config?.commonParams?.slardar_session_id || ''
  }
})()

export const COMMON_STATIC_TAGS = {
  ads_session_id: window.sessionId || '',
  slardar_session_id: SLARDAR_SESSION_ID || '',
  adv_id: GLOBAL_VAR.advertiser?.id || '',
  first_industry_id_v3: GLOBAL_VAR.advertiser?.first_industry_id_v3 || '',
  second_industry_id_v3: GLOBAL_VAR.advertiser?.second_industry_id_v3 || '',
  customer_type: GLOBAL_VAR.customerType || '',
  user_id: GLOBAL_VAR.coreUser?.id || ''
}

export const requestRenderMetricSetting = {
  request: [REQUEST_START, REQUEST_END],
  render: [REQUEST_END, RENDER_END],
  total: [REQUEST_START, RENDER_END]
}

export const downloadMetricSetting = {
  request: [REQUEST_START, REQUEST_END],
  total: [REQUEST_START, REQUEST_END]
}

export const GENERAL_TTI_METRIC_SETTING = {
  html: ['nav.fetchStart', 'nav.responseEnd'],
  init: ['nav.responseEnd', REQUEST_START],
  request: [REQUEST_START, REQUEST_END],
  render: [REQUEST_END, RENDER_END],
  total: ['nav.fetchStart', RENDER_END]
}
